// s8receipt-2f6d9a41 — when the staff Approval Details card is shown. Mirror of
// functions/utils/approvalReceipt.js hasApprovalReceipt (getQuoteApprovalDetails uses that one —
// both must agree or the card asks and gets nothing). Approved (any legacy spelling) OR
// AwaitingDeposit (customer signed, required deposit still owed), with an approval to point at.
// Before: 'Approved' only — a check from June 2026 that predates AwaitingDeposit (2026-07-15).
import { isApprovedStatus, QUOTE_STATUSES } from './quoteSchema';

// s8totals-6a1c3e85 — is this a PARTIAL approval whose approved totals should be shown instead of
// the original? Approved OR AwaitingDeposit (founder decision 2026-10-05; the portal already shows
// approved figures for both). Same rule as the PDF renderer (functions/index.js generateQuoteHtml).
export const resolveApprovalBreakdown = (quote) => {
    const q = quote || {};
    const signed = isApprovedStatus(q.status) || q.status === QUOTE_STATUSES.AWAITING_DEPOSIT;
    const hasApprovalBreakdown = signed && Array.isArray(q.approvedItemIds) && Array.isArray(q.declinedItemIds);
    return {
        hasApprovalBreakdown,
        isPartialApproval: hasApprovalBreakdown && q.declinedItemIds.length > 0,
    };
};

export const hasApprovalReceipt = (quote) => {
    if (!quote) return false;
    const signed = isApprovedStatus(quote.status) || quote.status === QUOTE_STATUSES.AWAITING_DEPOSIT;
    return signed && typeof quote.latestApprovalId === 'string' && quote.latestApprovalId.length > 0;
};
